import React, {useState, useRef, useEffect} from "react";
import {Select} from "uikit";
import styles from './MultiSelect.module.scss';
import CrossIcon from "@/assets/images/icons/12/close.svg";

const MultiSelect = ({ initialTags, createTag, options, onChange, input = true }: { initialTags?: any, onChange: any, createTag: any, options: any; input?: boolean }) => {
    const [selectedTags, setSelectedTags] = useState(initialTags);
    const [inputValue, setInputValue] = useState("");
    const inputRef = useRef(null);

    useEffect(() => {
        setSelectedTags(initialTags)
    }, [initialTags]);

    useEffect(() => {
        onChange(selectedTags)
    }, [selectedTags]);

    const handleInputChange = (e) => {
        setInputValue(e.target.value);
    };

    const handleKeyDown = async (e) => {
        if ((e.key === "Enter" || e.key === "") && inputValue.trim() !== "") {
            e.preventDefault();
            const newTag = await createTag(inputValue.trim());
            addTag(newTag);
            setInputValue("");
        }
        if (e.key === "Backspace" && inputValue === "" && selectedTags.length > 0) {
            removeTag(selectedTags[selectedTags.length - 1]);
        }
    };

    const addTag = (tag) => {
        if (!selectedTags.some(t => t.id === tag.id)) {
            setSelectedTags([...selectedTags, tag]);
        }
    };

    const removeTag = (tagToRemove) => {
        setSelectedTags(selectedTags.filter((tag) => tag.id !== tagToRemove.id));
    };

    const handleOptionClick = (tag) => {
        const selectedOption = options.find(option => option.id === tag);
        if (selectedOption) {
            addTag(selectedOption);
        }

        setInputValue("");
    };

    const handleFocus = () => {
        inputRef.current.style.border = '1px solid #0046F2';
        inputRef.current.style.boxShadow = '0 0 0 2px #A3D5FF';
    };

    const handleBlur = () => {
        inputRef.current.style.border = '1px solid #A7B0CA';
        inputRef.current.style.boxShadow = 'none';
    }

    return (
        <div style={{ position: "relative", width: "100%" }}>
            <Select data={Object.fromEntries(options.map(item => [item.id, item.title]))} onChange={(e) => handleOptionClick(e)}>
                <div
                    className={styles.container}
                    ref={inputRef}
                >
                    {selectedTags.map((tag, index) => (
                        <div
                            key={index}
                            className={styles.selectItems}
                        >
                            <p>{tag.title}</p>
                            <div onClick={() => removeTag(tag)}><CrossIcon /></div>
                        </div>
                    ))}
                    {input ? <input
                        type="text"
                        value={inputValue}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        onChange={handleInputChange}
                        onKeyDown={handleKeyDown}
                        placeholder={selectedTags.length === 0 ? 'Введите теги' : null}
                        className={styles.input}
                        /> : null
                    }
                </div>
            </Select>
        </div>
    );
};

export default MultiSelect;
